<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 文件浏览
-->
<template>
  <div class="previewFile">
    <div class="leftSlider" v-if="isArray(previewFileData)">
      <el-card style="height: 100%">
        <el-tree
          ref="tree"
          :data="previewFileData"
          :current-node-key="current"
          node-key="id"
          default-expand-all
          highlight-current
          :props="defaultProps"
          @node-click="handleNodeClick"
        ></el-tree>
      </el-card>
    </div>
    <div
      :class="{
        contentArray: isArray(previewFileData),
        contentObject: isObject(previewFileData)
      }"
      v-loading="loading"
      class="content-container"
    >
      <iframe
        v-if="url"
        :key="new Date().getTime()"
        :src="url"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>

      <!-- 下一张按钮 -->
      <div v-if="showNextButton" class="next-button-container">
        <el-button
          type="primary"
          size="small"
          :disabled="!hasNextFile"
          @click="goToNextFile"
          icon="el-icon-arrow-right"
        >
          下一张
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64';
import config from '../../config';
export default {
  name: 'previewFile',

  data() {
    return {
      loading: false,
      pictures: [],
      allFiles: [], // 所有文件列表
      baseUrl: config.previewURL,
      url: '', //预览服务地址
      current: '',
      currentFileIndex: 0 // 当前文件索引
    };
  },
  computed: {
    previewFileData() {
      return JSON.parse(window.sessionStorage.previewFileData);
    },
    defaultProps() {
      if (window.sessionStorage.defaultProps) {
        return JSON.parse(window.sessionStorage.defaultProps);
      } else {
        return { children: 'children', label: 'label' };
      }
    },
    currentFile() {
      return window.sessionStorage.currentFile;
    },
    // 是否显示下一张按钮（有多个文件时显示，无论是图片还是其他文件）
    showNextButton() {
      return this.url && this.allFiles.length > 1;
    },
    // 是否还有下一个文件
    hasNextFile() {
      return this.currentFileIndex < this.allFiles.length - 1;
    }
  },
  mounted() {
    this.getPictures();
    this.init();
  },
  methods: {
    init() {
      if (this.isObject(this.previewFileData)) {
        this.current = this.currentFile;
        this.handleNodeClick(this.previewFileData);
      } else if (this.isArray(this.previewFileData)) {
        if (this.currentFile) {
          this.current = this.currentFile;
          this.setDefaultUrl(this.previewFileData, this.current);
        } else {
          this.setDefaultUrl(this.previewFileData);
        }
      }
    },
    //假如没指定 默认查找第一个url显示 传id就去递归找id
    setDefaultUrl(list, id) {
      for (const iterator of list) {
        if (iterator.url) {
          if (id) {
            if (id == iterator.id) {
              this.$refs.tree.setCurrentKey(iterator.id, true);
              this.handleNodeClick(iterator);
            }
          } else {
            this.current = iterator.id;
            this.$refs.tree.setCurrentKey(iterator.id, true);
            this.handleNodeClick(iterator);
          }
        } else if (iterator.children && iterator.children.length > 0) {
          this.setDefaultUrl(iterator.children, id);
        }
      }
    },
    /**
     * @description: 判断是否图片
     * @param {*} fileName
     * @return {*}
     * @author: Junchi Zhao
     */
    isPicture(fileName) {
      if (!fileName) {
        return false;
      } else {
        return /\.(bmp|jpg|jpeg|png|GIF|BMP|JPG|PNG)$/.test(fileName);
      }
    },
    handleNodeClick(data) {
      if (data.url) {
        this.loading = true;
        this.url = '';
        this.$nextTick(() => {
          // 更新当前文件索引
          this.currentFileIndex = this.allFiles.findIndex((item) => item.id === data.id);
          if (this.isPicture(this.getQuery('fullfilename', data.url))) {
            const urls = this.pictures.filter((item) => item.id != data.id).map((item) => item.url);
            urls.unshift(data.url);
            this.url =
              config.previewURL +
              '/picturesPreview?urls=' +
              window.encodeURIComponent(Base64.encode(urls.join('|')));
          } else {
            this.url =
              config.previewURL +
              '/onlinePreview?url=' +
              window.encodeURIComponent(Base64.encode(data.url));
          }
          this.loading = false;
        });
      }
    },
    getQuery(name, url) {
      if (!url) {
        return;
      }
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      const r = url.split('?')[1].match(reg);
      if (r != null) return unescape(r[2]);
      return '';
    },
    getPic(data) {
      for (const iterator of data) {
        if (iterator.url && this.isPicture(this.getQuery('fullfilename', iterator.url))) {
          this.pictures.push(iterator);
        }
        if (
          iterator[this.defaultProps.children] &&
          iterator[this.defaultProps.children].length > 0
        ) {
          this.getPic(iterator[this.defaultProps.children]);
        }
      }
    },
    getPictures() {
      if (this.previewFileData) {
        if (this.isArray(this.previewFileData)) {
          this.getPic(this.previewFileData);
          this.getAllFiles(this.previewFileData);
        } else if (this.isObject(this.previewFileData)) {
          // 处理单个文件对象的情况
          if (this.previewFileData.url) {
            this.allFiles.push(this.previewFileData);
            if (this.isPicture(this.getQuery('fullfilename', this.previewFileData.url))) {
              this.pictures.push(this.previewFileData);
            }
          }
        }
      }
    },
    getAllFiles(data) {
      for (const iterator of data) {
        if (iterator.url) {
          this.allFiles.push(iterator);
        }
        if (
          iterator[this.defaultProps.children] &&
          iterator[this.defaultProps.children].length > 0
        ) {
          this.getAllFiles(iterator[this.defaultProps.children]);
        }
      }
    },
    /**
     * @description: 判断当前是否在预览图片
     * @return {Boolean}
     * @author: Junchi Zhao
     */
    isCurrentlyViewingPicture() {
      if (!this.url || this.pictures.length === 0) return false;
      return this.url.includes('/picturesPreview');
    },
    /**
     * @description: 切换到下一张（支持图片和其他文件类型）
     * @author: Junchi Zhao
     */
    goToNextFile() {
      if (!this.hasNextFile) return;

      const nextIndex = this.currentFileIndex + 1;
      const nextFile = this.allFiles[nextIndex];

      if (nextFile) {
        // 更新树形控件的选中状态
        this.current = nextFile.id;
        this.$refs.tree && this.$refs.tree.setCurrentKey(nextFile.id, true);

        // 调用节点点击事件来切换文件
        this.handleNodeClick(nextFile);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.previewFile {
  height: 100%;
  display: flex;
  .leftSlider {
    height: 100%;
    width: 200px;
  }
  .content-container {
    position: relative;
  }
  .contentArray {
    width: calc(100% - 200px);
    padding: 10px;
  }
  .contentObject {
    width: 100%;
    padding: 10px;
  }
  .next-button-container {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
  }
}
::v-deep .el-tree-node__label {
  overflow: hidden;
}
</style>
